module.exports = __webpack_public_path__ + "img/about-us.14c999ab.jpg";